module.exports = __webpack_public_path__ + "img/network_security-768.40d78296.jpg";